import React, { useImperativeHandle, useRef, forwardRef } from 'react';
import { importMails } from '../../util';
import useState2RM from '../../hooks/useState2ReduxMock';
import { Thunks } from '@web-common/state/reducer/mailReducer';
import { useAppDispatch } from '@web-common/state/createStore';
const EmlUploader = (props, ref) => {
    const dispatch = useAppDispatch();
    const uploadFileRef = useRef(null);
    const [importFolderId] = useState2RM('importFolderId');
    const onFileChange = (node) => {
        const fileUploader = uploadFileRef.current;
        if (!fileUploader) {
            return;
        }
        const { files } = fileUploader;
        if ((files === null || files === void 0 ? void 0 : files.length) && (importFolderId === null || importFolderId === void 0 ? void 0 : importFolderId.folderId)) {
            importMails({ fid: Number(importFolderId.folderId), fileList: Array.from(files), _account: importFolderId.accountId }).then(() => {
                dispatch(Thunks.refreshMailList({
                    noCache: true,
                    showLoading: false,
                }));
            });
        }
    };
    const onFileClick = (e) => {
        e.target.value = '';
    };
    useImperativeHandle(ref, () => uploadFileRef.current);
    return React.createElement("input", { type: "file", accept: ".eml", hidden: true, multiple: true, ref: uploadFileRef, onChange: onFileChange, onClick: onFileClick });
};
export default forwardRef(EmlUploader);
